// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-label {
  flex: 1;
}

ion-label + ion-select {
  flex: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/ril-filter/ril-filter.component.scss"],"names":[],"mappings":"AAAA;EACE,OAAA;AACF;;AACA;EACE,OAAA;AAEF","sourcesContent":["ion-label {\n  flex: 1;\n}\nion-label + ion-select {\n  flex: 0;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
